import React from "react";

const PrivacyPolicyPage = () => {
  window.location.assign("https://1m-help-docs.s3.us-west-1.amazonaws.com/privacy-policy.html")
  return null
}

export default PrivacyPolicyPage